export default __webpack_public_path__ + "static/MediaContentTwelve-72bc9113a46595f7787052e6f66c569a.webp";